import AbcProduto from './AbcProduto';

export default AbcProduto;